/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-recipient delivery result
 * @export
 * @interface DeliveryResult
 */
export interface DeliveryResult {
    /**
     * Recipient identifier (userId or email)
     * @type {string}
     * @memberof DeliveryResult
     */
    recipientId?: string;
    /**
     * Channel used (EMAIL, SMS, etc.)
     * @type {string}
     * @memberof DeliveryResult
     */
    channel?: string;
    /**
     * Whether delivery succeeded
     * @type {boolean}
     * @memberof DeliveryResult
     */
    success?: boolean;
    /**
     * Workflow ID if started
     * @type {string}
     * @memberof DeliveryResult
     */
    workflowId?: string;
    /**
     * Error message if failed
     * @type {string}
     * @memberof DeliveryResult
     */
    error?: string;
    /**
     * Reason if skipped (e.g. opted out, no address)
     * @type {string}
     * @memberof DeliveryResult
     */
    skipReason?: string;
}

/**
 * Check if a given object implements the DeliveryResult interface.
 */
export function instanceOfDeliveryResult(value: object): value is DeliveryResult {
    return true;
}

export function DeliveryResultFromJSON(json: any): DeliveryResult {
    return DeliveryResultFromJSONTyped(json, false);
}

export function DeliveryResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryResult {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'success': json['success'] == null ? undefined : json['success'],
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'error': json['error'] == null ? undefined : json['error'],
        'skipReason': json['skipReason'] == null ? undefined : json['skipReason'],
    };
}

export function DeliveryResultToJSON(json: any): DeliveryResult {
    return DeliveryResultToJSONTyped(json, false);
}

export function DeliveryResultToJSONTyped(value?: DeliveryResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientId': value['recipientId'],
        'channel': value['channel'],
        'success': value['success'],
        'workflowId': value['workflowId'],
        'error': value['error'],
        'skipReason': value['skipReason'],
    };
}

